import React, { useEffect } from "react";
import { Row, Col, Card, Table, Button, Tooltip } from "antd";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaDownload } from "react-icons/fa";

const ColumnChart = ({ setTopTitle }) => {
  useEffect(() => {
    setTopTitle("Version Information");
  }, [setTopTitle]);

  const dataSource = [        
    { key: "1", version: "15.0.0", date: "26-02-2025",features:"Features", modules: "Asset Service ORL Pettycash", changes: "ORL Pettycash Request Expense, Approval GM, Claim Submission with Bill Copy"},
    { key: "2", version: "14.1.1", date: "26-02-2025",features:"Features", modules: "Consumable Entry 2.0", changes: "Consumable Entry - Outlet Orl have to enter the consumables details in their Hand, Cross check the consumable count based on the sales, Report"},
    { key: "3", version: "14.1.0", date: "02-12-2024", features:"Features", modules: "Audit 3.0", changes: "Audit Entry, Audit Report - Need to allow auditor to audit multiple times within the month"},
    { key: "4", version: "14.0.0", date: "13-09-2024",features:"Features", modules: "Operations Facility Review (OFR)", changes: "Daily Enter the Key Points, Report"},
    { key: "5", version: "13.1.0", date: "01-08-2024",features:"Features", modules: "Calendar Events ( Phase II)", changes: "Assign Event for Marketing Team, Outlet Team, Calendar Report"},
    { key: "6", version: "13.0.0", date: "15-07-2024",features:"Features", modules: "Calendar Events ( Phase I)", changes: "Event creation"},
    { key: "7", version: "12.0.0", date: "13-07-2024",features:"Features", modules: "Consumable Entry", changes: "Consumable Entry - Outlet Orl have to enter the consumables details in their Hand, Report"},
    { key: "8", version: "11.1.3", date: "02-07-2024",features:"Features", modules: "Stock Expiry Report", changes: "Interface Rista Inventory Batch wise- Displaying Current rista stock count - Printout given"},
    { key: "9", version: "11.1.2", date: "28-06-2024",features:"Features", modules: "Dashboard Overall Payment Vs Sales", changes: "Dashboard Outlet Wise, Month wise -- WorldlineEDC, Zomato, Swiggy, Dotpe, MagicPin, Zaaroz  Sales Vs Bank Payment Report"},
    { key: "10", version: "11.1.1", date: "03-06-2024",features:"Features", modules: "Overall Payment VS Sales ( Cash,WorldlineEDC, Zomato, Swiggy, Dotpe, MagicPin, Zaaroz)", changes: "Outlet Wise, Date Wise -- WorldlineEDC, Zomato, Swiggy, Dotpe, MagicPin, Zaaroz  Sales Vs Bank Payment Report"},
    { key: "11", version: "11.1.0", date: "24-05-2024",features:"Features", modules: "Stock Taking(Printout)", changes: "Interface Rista Inventory - Displaying Current rista stock count - Printout given"},
    { key: "12", version: "11.0.0", date: "24-05-2024",features:"Features", modules: "EDC (WorldlineEDC, Zomato, Swiggy, Dotpe, MagicPin, Zaaroz)", changes: "WorldlineEDC, Zomato, Swiggy, Dotpe, MagicPin, Zaaroz  Sales Vs Bank Payment Report"},
    { key: "13", version: "10.0.0", date: "01-04-2024",features:"Features", modules: "EB Reading Activity", changes: "Budget gave to give based up on the equipements for the month,Daily Outlet ORL have to enter the reading details in Entry Screen as well attach the image,Back Office person will check and verify the entries,Reports- ORL, Backoffice"},
    { key: "14", version: "9.0.0", date: "29-02-2024",features:"Features", modules: "Asset Service", changes: "Ticket Creation based on issue raised Asset from outlet,Maintenance Supervisor will handle the ticket from first to till the issue solved status,In between, We have many cases like Cost Involved - Yes / No,If no means MS can close the ticket,If Yes means we have two more options - Online, Pettycash,Online means PO Process need to clear the issue,Pettycash means MS have to give the amount from his pettycash,For both the processes OH have the approval screen,For Pettycash Accounts manager have the option to do SAP FI Entry Process in Oyalo Pro,Report - Ticket Status Report,MS Pettycash Request,For both the processes OH have the approval screen,For Pettycash Accounts manager have the option to do SAP FI Entry Process in Oyalo Pro,Report - MS Pettycash Request Report"},
    { key: "15", version: "8.0.0", date: "11-01-2024",features:"Features", modules: "Deep Cleaning", changes: "Outlet Equipementwise need to assign the plan for Deep Cleaning,Outlet ORL have to do the entry once the cleaning process has been completed,  as well attach the image,Back Office person will check and verify the entries,Reports- ORL, Backoffice"},
    { key: "16", version: "7.0.0", date: "20-11-2023",features:"Features", modules: "Call Back Activity", changes: "Call Back Activity - Based on previous invoice details,Getting the user details like - DOB, Anniversary ,Scheme giving based on the DOB, Anniversary Dates"},
    { key: "17", version: "6.0.0", date: "24-10-2023",features:"Features", modules: "Outlet Cash Closure", changes: "Day-to-day Cash Sale Deposit Monitoring, Interface - Cash Sale data from Rista, Reports - ARM, Automatic Cash Closure date created - 12am in the name of status day closure - If not converted to deposit status, the previous day closure status will be converted into day closure pending, Sales Report - Rista." },
    { key: "18", version: "5.0.0", date: "17-08-2023",features:"Features", modules: "Audit 2.0 Incentive Payment", changes: "Approval - OH, AH, BH, AM, Auto Mail - HR Initiation, OH Approval, AH Approval, BH Approval, AM Payment Process, Hygiene - Incentive Payment through Audit 2.0 - Directly integrating with SAP - reducing SAP manpower dependency, Interface - Payment in SAP" },
    { key: "19", version: "4.0.0", date: "09-06-2023",features:"Features", modules: "License Capture", changes: "License Statutory - Monitoring Outlet License updation, Expiry License Intimation - through Mail before 45 days, Auto Mail - Creating License, Renewal, Acknowledgement Submission, Expiry intimation, Expired" },
    { key: "20", version: "3.0.0", date: "04-07-2023",features:"Features", modules: "Audit 2.0", changes: "Separated Hygiene and Department Points for audit entry, Major correction - Entries made mobile friendly for both Audit, CAPA Submission & Approval Screens, Attachment, Remarks made mandatory for CAPA Submission, CAPA - Display of old attachments and remarks made visible with new attachments and remarks for comparison, Remarks made visible during recheck of CAPA Submission, Auto Mail - Submission of Audit Entry" },
    { key: "21", version: "2.1.0", date: "11-04-2023",features:"Features", modules: "Overall Training", changes: "Overall Training - Video, Image, Document for Overall Training for All Purpose" },
    { key: "22", version: "2.0.0", date: "15-03-2023",features:"Features", modules: "Category Wise Training", changes: "Training - Video, Image, Document for Audit Entry Purpose" },
    { key: "23", version: "1.0.0", date: "01-02-2023",features:"Features", modules: "Audit 1.0", changes: "Audit Entry - Avoided Spreadsheet Manual Entries, Consolidated View Audit Points in a Single Page, Entry Fields are made mandatory to avoid skipping of entries, Recheck allowed to resubmit CAPA Points" },
  ];

  const columns = [
    { title: "Version", dataIndex: "version", key: "version" },
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Modules", dataIndex: "modules", key: "modules" },
    { title: "Features/Bugs", dataIndex: "features", key: "features" },
    { title: "Changes", dataIndex: "changes", key: "changes" }
  ];

  // Function to export to Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(dataSource.map(({ ...rest }) => rest));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "VersionInfo");   
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Oyalo_Pro_VersionInfo.xlsx");
  };

  return (
    <div>
      <Card>
        {/* Header with Title and Export Button */}
        <Row gutter={[25, 0]} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          {/* Centered Title */}
          <Col md={12} xs={24} style={{ display: "flex", justifyContent: "center" }}>
            <h1 style={{ 
              color: "#f5a60b",
              borderRadius: "10px",
              border: "none",
              padding: "1px 2px",
              fontSize: "36px",
              fontWeight: "bold",
              cursor: "pointer",
              textAlign: "right",
              width: "100%"
            }}>
              Oyalo Pro
            </h1>           
          </Col>
          {/* Right-aligned Export Button */}
          <Col md={12} xs={24} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Tooltip title="Export Excel">
              <Button type="primary" onClick={exportToExcel} style={{
                backgroundColor: "#f5a60b",
                color: "white",
                borderRadius: "10px",
                border: "none",
                padding: "13px 23px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
                transition: "transform 0.2s"
              }}>           
                <FaDownload />
              </Button>
            </Tooltip>
          </Col>
        </Row>

        {/* Table */}
        <Col md={24} xs={24} span={24}>           
          <Table
            dataSource={dataSource}
            columns={columns}
            pagination={{ pageSize: 8 }}
            rowClassName={(record, index) => (index % 2 === 0 ? "table-row-light" : "table-row-dark")}
            bordered
          />
        </Col>

        {/* Custom Table Styles */}
        <style>
          {`
            .ant-table-thead > tr > th {
              background-color: #f5a60b !important;
              color: white !important;
              font-weight: bold !important;
              text-align: center;
            }
            .table-row-light {
              background-color: #fff;
            }
            .table-row-dark {
              background-color: #f3e6db;
            }
          `}
        </style>
      </Card>
    </div>
  );
};

export default ColumnChart;
